module.exports = __webpack_public_path__ + "1d16cc4ee9dbcdb7667149ff55d673f8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/calendar.svg
// module id = 78
// module chunks = 0